import { Outlet } from 'react-router-dom';

function ReportsPage() {
  return (
    <>
      <Outlet />
    </>
  );
}

export default ReportsPage;
